<template>
  <div class="login-page">
    <div class="login-card card">
      <img src="../assets/logo_igreja.png" alt="El Shaday" class="login-logo" />
      <h1 class="login-title">Painel global</h1>
      <p class="login-subtitle">Gerenciar encontros · ROOT global</p>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label class="label" for="email">Email</label>
          <input class="input" type="email" id="email" v-model="form.email" placeholder="seu@email.com" required />
        </div>
        <div class="form-group">
          <label class="label" for="password">Senha</label>
          <input class="input" type="password" id="password" v-model="form.password" placeholder="Sua senha" required />
        </div>
        <p v-if="erro" class="erro">{{ erro }}</p>
        <button type="submit" class="btn-primary login-btn" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>

      <p class="muted small">
        Sou voluntário ou admin de um encontro: acesse pelo subdomínio dele
        (<code>encontro.checkin.naelshaday.com.br</code>).
      </p>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth'

export default {
  name: 'GlobalLoginPage',
  data() {
    return {
      form: { email: '', password: '' },
      loading: false,
      erro: ''
    }
  },
  methods: {
    async handleLogin() {
      this.erro = ''
      this.loading = true
      try {
        const store = useAuthStore()
        await store.login(this.form.email, this.form.password)
        if (!store.isRoot || store.admin?.encontroId !== null) {
          store.logout()
          this.erro = 'Apenas ROOT global pode acessar o painel global.'
          return
        }
        this.$router.replace('/')
      } catch (err) {
        this.erro = err.response?.data?.message || 'Falha ao entrar'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh; display: flex; align-items: center; justify-content: center;
  background: #0f172a; padding: var(--spacing-base);
}
.login-card {
  background: white; max-width: 420px; width: 100%;
  padding: var(--spacing-lg); border-radius: var(--radius-md);
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
}
.login-logo { display: block; margin: 0 auto var(--spacing-base); width: 80px; height: 80px; object-fit: contain; }
.login-title { text-align: center; margin: 0 0 4px; }
.login-subtitle { text-align: center; color: var(--color-text-muted); margin: 0 0 var(--spacing-base); font-size: var(--text-sm); }
.form-group { display: flex; flex-direction: column; gap: 4px; margin-bottom: var(--spacing-sm); }
.input { padding: 10px 12px; border: 1px solid var(--color-border); border-radius: var(--radius-md); font-size: var(--text-base); }
.login-btn { width: 100%; padding: 12px; }
.erro { background: #fee2e2; color: #b91c1c; padding: 8px 12px; border-radius: var(--radius-md); font-size: var(--text-sm); margin: 8px 0; }
.muted { color: var(--color-text-muted); }
.small { font-size: var(--text-sm); margin-top: var(--spacing-base); text-align: center; }
code { background: #f1f5f9; padding: 1px 4px; border-radius: 4px; font-size: 0.9em; }
</style>
